import AuthService from './AuthService'
import HomeService from './HomeService'
import RestClient from './RestClient'
import UserService from './UserService'
import FileService from './FileService'
import WebSocketService from './WebSocketService'
import ItemService from './ItemService'
import AdminService from './AdminService'
import TipService from './TipService'

export const restClient = new RestClient()
export const authService = new AuthService(restClient)
export const userService = new UserService(restClient)
export const homeService = new HomeService(restClient)
export const fileService = new FileService(restClient)
export const webSocketService = new WebSocketService()
export const itemService = new ItemService(restClient)
export const adminService = new AdminService(restClient)
export const tipService = new TipService()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/index.ts